import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
 {
    path: '/Homepage',
    component: () => import('@/routes/Homepage'),
    name: 'Homepage'
  },
  {
    path: '/ContactUs',
    component: () => import('@/routes/ContactUs'),
    name: 'ContactUs'
  },
  {
    path: '/About',
    component: () => import('@/routes/About'),
    name: 'About'
  },
  {
    path: '/News',
    component: () => import('@/routes/News'),
    name: 'News'
  },
  {
    path: '/Article',
    component: () => import('@/routes/Article'),
    name: 'Article'
  },
  {
    path: '/Projects',
    component: () => import('@/routes/ProjectsNav'),
    name: 'ProjectsNav'
  },
  {
    path: '/Projects/All',
    component: () => import('@/routes/ProjectsNav2'),
    name: 'ProjectsNav2'
  },
  {
    path: '/Available/Projects',
    component: () => import('@/routes/ProjectsNav2'),
    name: 'Available Projects'
  },
  {
    path: '/Projects/All/Old',
    component: () => import('@/routes/ProjectsNav2'),
    name: 'ProjectsNav2Old'
  },
  {
    path: '/Project',
    component: () => import('@/routes/Project'),
    name: 'Project'
  },
  { 
    path: '/', 
    redirect: '/Homepage' 
  }
]

const router = new Router({routes});

export default router;